export enum RouteDirection {
  N = 'n',
  E = 'e',
  S = 's',
  W = 'w',
  NE = 'ne',
  SE = 'se',
  SW = 'sw',
  NW = 'nw',
}
